import { NetworkService } from "./NetworkService";

export class MonitoringService {
  static async getDatesHomePage() {
    try {
      return await NetworkService.request({
        url: "monitoring",
        method: "GET",
      }).then((response) => {
        return response;
      }).catch((error) => {
        console.log(error);
      });
    } catch (e) {
      return e
    }
  }

  static async downloadListFinished() {
    await NetworkService.requestDownload({
      url: "monitoring/download/finalized",
      fileName: "finalized.csv"
    })
  }

}

